// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"ff90b921","453":"8926671d"}[chunkId] + ".chunk.js";
};